import { render, staticRenderFns } from "./settingsHub.vue?vue&type=template&id=f98e420e&scoped=true&"
import script from "./settingsHub.vue?vue&type=script&lang=js&"
export * from "./settingsHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98e420e",
  null
  
)

export default component.exports